import Box from '@mui/material/Box';
import { StoryblokComponent, storyblokEditable } from '@storyblok/react';
import { object, string } from 'prop-types';
import React from 'react';

const storyblokPageComponentDefaultPropBlok = {
  content: [],
  metatags: {
    title: '',
    description: '',
  },
};

const StoryblokPageComponent = ({ blok = storyblokPageComponentDefaultPropBlok }) => {
  return (
    <Box
      sx={{
        '&>:nth-of-type(2n)': {
          backgroundColor: 'var(--matterColorLight)',
        },
      }}
      {...storyblokEditable(blok)}
      key={blok._uid}
    >
      {blok.content?.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </Box>
  );
};

StoryblokPageComponent.prototype = {
  blok: object,
  pageName: string.isRequired,
};

export default StoryblokPageComponent;
